var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { cloneDeep } from 'lodash';
import promiseLimit from 'promise-limit';
import { Icon, Wrapper } from '@mademine/components';
import { ObjectURL, Image } from '@mademine/utils';
import { ReactComponent as ArrowLeft } from '../assets/icon-arrow-left.svg';
import Croppie from '../components/Cropper';
var Cropper = function (_a, ref) {
    var sources = _a.sources, type = _a.type, _b = _a.maxZoom, maxZoom = _b === void 0 ? 2 : _b, unifyCropper = _a.unifyCropper, _c = _a.aloneCropper, aloneCropper = _c === void 0 ? [] : _c, maxCropperRatio = _a.maxCropperRatio, onClose = _a.onClose, onConfirm = _a.onConfirm, onExchangeImage = _a.onExchangeImage;
    var _d = useState(), croppieSource = _d[0], setCroppieSource = _d[1];
    var _e = useState([]), _sources = _e[0], setSources = _e[1];
    var _f = useState(-1), clickSourceIndex = _f[0], setClickSourceIndex = _f[1];
    var _limit = promiseLimit(4);
    useImperativeHandle(ref, function () { return ({
        onResetActive: function () {
            setClickSourceIndex(-1);
        },
        onChangeImage: function (source) {
            handleZuploaderConfirm(source);
        },
        onCropper: function () {
            setCroppieSource(_sources[clickSourceIndex]);
        }
    }); });
    var _imageCropper = function (source, paramCropper) { return __awaiter(void 0, void 0, void 0, function () {
        var _image, blobURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!paramCropper) return [3, 2];
                    _image = new Image()
                        .load(source)
                        .orientation()
                        .cropper(paramCropper[0] / paramCropper[1]);
                    return [4, _image.toBlobURL()];
                case 1:
                    blobURL = _a.sent();
                    _image.dispose();
                    return [2, blobURL];
                case 2: return [2, source];
            }
        });
    }); };
    useEffect(function () {
        if (sources.length === 1)
            setCroppieSource({
                source: sources[0],
                paramCropper: type === 'alone' ? aloneCropper[0] : unifyCropper
            });
        else {
            Promise.all(sources
                .map(function (source, index) { return ({
                source: source,
                paramCropper: type === 'alone' ? aloneCropper[index] : unifyCropper
            }); })
                .map(function (_a) {
                var source = _a.source, paramCropper = _a.paramCropper;
                return _limit(function () {
                    return _imageCropper(source, paramCropper).then(function (cropper) { return ({
                        source: source,
                        cropper: cropper,
                        paramCropper: paramCropper
                    }); });
                });
            }))
                .then(function (datas) {
                setSources(datas);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
    }, []);
    var handleCroppieClose = function () {
        setCroppieSource(undefined);
        if (sources.length === 1)
            onClose();
    };
    var handleCroppieConfirm = function (blob, cropperData) {
        if (sources.length === 1) {
            onConfirm({
                images: [ObjectURL.create(blob)],
                datas: [cropperData]
            });
        }
        else if (croppieSource) {
            croppieSource.cropper = ObjectURL.create(blob);
            croppieSource.cropperData = cropperData;
            setSources(cloneDeep(_sources));
            setCroppieSource(undefined);
        }
    };
    var handleZuploaderConfirm = function (images) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(clickSourceIndex >= 0)) return [3, 2];
                    _sources[clickSourceIndex].source = images[0].objectURL;
                    _a = _sources[clickSourceIndex];
                    return [4, _imageCropper(images[0].objectURL, _sources[clickSourceIndex].paramCropper)];
                case 1:
                    _a.cropper = _b.sent();
                    setSources(cloneDeep(_sources));
                    return [3, 4];
                case 2: return [4, Promise.all(_sources
                        .filter(function (item) { return !item.cropper; })
                        .slice(0, images.length)
                        .map(function (item, index) {
                        return _imageCropper(images[index].objectURL, item.paramCropper).then(function (data) {
                            item.source = images[index].objectURL;
                            item.cropper = data;
                        });
                    }))];
                case 3:
                    _b.sent();
                    setSources(cloneDeep(_sources));
                    _b.label = 4;
                case 4:
                    if (!onExchangeImage)
                        setClickSourceIndex(-1);
                    return [2];
            }
        });
    }); };
    return (_jsx(Wrapper, { className: "_sz-absolute _sz-inset-0 _sz-z-30 _sz-animate-right-pnyal _sz-bg-white", children: croppieSource && (_jsx(Croppie, { source: croppieSource, renderHeaderCloseContent: _jsx(Icon, { size: 30, children: _jsx(ArrowLeft, {}) }), maxZoom: maxZoom, maxCropperRatio: maxCropperRatio, onClose: handleCroppieClose, onConfirm: handleCroppieConfirm })) }));
};
export default forwardRef(Cropper);
